import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    public workflows: any[] = [
        {
            title: '제안서 작성',
            caption: '문제, 해결안, 일정, 예산, 기대효과를 갖춘 문서',
            href: '/workspace/proposal',
            status: 'Proposal',
            tone: 'indigo'
        },
        {
            title: '제안서 기반 발표자료 작성',
            caption: '완성된 제안서를 발표 흐름과 장표로 변환',
            href: '/workspace/proposal-slides',
            status: 'Slides',
            tone: 'emerald'
        },
        {
            title: '발표자료 작성',
            caption: '주제, 청중, 발표 시간에 맞춘 슬라이드 구성',
            href: '/workspace/slides',
            status: 'Deck',
            tone: 'sky'
        },
        {
            title: '보고서 작성',
            caption: '조사, 논문형 보고서, 출처 기반 분석 문서',
            href: '/workspace/report',
            status: 'Report',
            tone: 'amber'
        }
    ];

    public stats: any[] = [
        { label: '작업 유형', value: '4' },
        { label: '웹 발표자료', value: '2' },
        { label: '그림 자료', value: '4' },
        { label: '출처 자료', value: '23' }
    ];

    public outputs: any[] = [
        { title: 'Harness Engineering 적용 웹 발표자료', caption: '하네스 구조와 적용 로드맵을 담은 슬라이드 덱', href: '/slides/harness-engineering' },
        { title: 'AI 생성물 폐해 웹 발표자료', caption: '20분 발표용 HTML/CSS 슬라이드 덱', href: '/slides/ai-harms' },
        { title: 'AI 생성물 폐해 보고서', caption: '논문형 보고서 예시 산출물', href: '/ai-report' },
        { title: '자료 아카이브', caption: '기존 제안서와 산출물 보관 화면', href: '/archive' },
        { title: '게시물 관리', caption: '콘텐츠/문서 항목 관리', href: '/posts' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public toneClass(tone: string) {
        switch (tone) {
            case 'emerald': return 'bg-emerald-50 text-emerald-700 border-emerald-100';
            case 'sky': return 'bg-sky-50 text-sky-700 border-sky-100';
            case 'amber': return 'bg-amber-50 text-amber-700 border-amber-100';
            default: return 'bg-indigo-50 text-indigo-700 border-indigo-100';
        }
    }
}

export default PageDashboardComponent;